<script setup lang="ts">
    import { onMounted, inject } from 'vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { UpdatesAccess } from '@views/Updates/Updates.access';
    import Loading from '@shared/components/Loading.vue';
    import BsAlert from '@shared/components/BsAlert.vue';
    import { AlertTypes } from '@shared/components/BsAlerts';
    import HumanTime from '@shared/utils/HumanTime/HumanTime';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const updatesAccess: UpdatesAccess = injectorAccess.injector.get(UpdatesAccess);
    const humanTime = new HumanTime();

    onMounted(async () => {
        await updatesAccess.loadUpdates();
    });
</script>

<template>
    <div class="container max-600">
        <h1 class="m-xl-b">{{ $Resources.ArchiveHeading }}</h1>

        <template v-if="updatesAccess.state.posts.length > 0">
            <div v-for="(post, index) in updatesAccess.state.posts" :key="post.Id">
                <div v-if="post.featured_image_full_urls?.Full">
                    <img :src="post.featured_image_full_urls.Full" :alt="post.Title.Rendered" class="img-responsive center-block" />
                </div>

                <h2 class="m-sm-t" v-html="post.Title.Rendered"></h2>

                <ul v-if="post.post_categories?.length > 0" class="tag-list list-unstyled m-xs-b">
                    <li v-for="category in post.post_categories" :key="category">
                        <span class="tag">{{ category }}</span>
                    </li>
                </ul>

                <div class="m-lg-b" v-html="post.Content.Rendered"></div>

                <p class="meta">
                    <span class="glyphicon glyphicon-time"></span>
                    {{ humanTime.parse(post.Date) }}
                </p>

                <hr />
            </div>
        </template>

        <BsAlert
            class="m-lg-t"
            v-if="!updatesAccess.state.loading && updatesAccess.state.posts.length === 0"
            :type="AlertTypes.Info"
            :dismissible="false"
            :content="$Resources.NoEntriesAlertContent" />

        <Loading :show="updatesAccess.state.loading" />
    </div>
</template>

